module.exports = __webpack_public_path__ + "static/media/CloseRum.ecbd59f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/CloseRum.svg
// module id = 660
// module chunks = 0